/* eslint-disable no-console */
import {
  CA_DOCUMENT_TYPE_VALUES,
  CADocumentTypeValue
} from '../../../pages/aiDocumentManager/Constants/commonConstants';
import {APITypeEnum} from '../../../services/interface/tableAPIType';
import businessTravelAPI from '../../../services/modules/IP/businessTravelAPI';
import capitalGoodsAPI from '../../../services/modules/IP/capitalGoodAPI';
import electricityAPI from '../../../services/modules/IP/electricityAPI';
import fugitiveAPI from '../../../services/modules/IP/fugitiveAPI';
import machineDetails from '../../../services/modules/IP/machineAPI';
import supplyChainAPI from '../../../services/modules/IP/supplyChainAPI';
import vehicleAPI from '../../../services/modules/IP/vehicleAPI';
import waterAPI from '../../../services/modules/IP/waterAPI';
import deviceFuelAPI from '../../../services/modules/JSON/deviceFuel';
import deviceTypeAPI from '../../../services/modules/JSON/deviceType';
import electricBoard from '../../../services/modules/JSON/electricBoard';
import emissionSourceJSON from '../../../services/modules/JSON/emissionSource';
import frequencyJSON from '../../../services/modules/JSON/frequency';
import fuelTypeAPI from '../../../services/modules/JSON/fuelType';
import modeOfTransportJSON from '../../../services/modules/JSON/modeOfTransport';
import modeOfTransportTravJSON from '../../../services/modules/JSON/modeOfTransportByTravel';
import refrigerantTypeJSON from '../../../services/modules/JSON/refrigentType';
import refrigerantUsed from '../../../services/modules/JSON/refriUsed';
import renewableTypeAPI from '../../../services/modules/JSON/renewableType';
import vehicleFuelUsedJSON from '../../../services/modules/JSON/vehicleFuelUsed';
import vehicleTypeAPI from '../../../services/modules/JSON/vehicleType';
import waterSourceJSON from '../../../services/modules/JSON/waterSource';
import supplierInfo from '../../../services/modules/OM/supplierInfoDetails';
import productInfoAPI from '../../../services/modules/PRODUCTS/ProductInfoAPI';
import rawMaterialAPI from '../../../services/modules/PRODUCTS/rawMaterialAPI';

export interface IType {
  key: string;
  value: string;
}

export const PerquisiteMasterAPIIds = {
  SUPPLIER: 'supplier'
};

export interface IPreConfig {
  mainAPI: any;
  PerquisiteMasterAPIIds: any[];
  billType: string;
  componentName: string;
  PerquisiteMasterAPIs: any[];
  props: any;
  type: IType | null;
  initialValues: {
    facility?: string;
    year?: number | string;
  };
  isConfigurator: boolean;
  isAction: boolean;
}
const getPrerequisiteMasterData = (record: any): IPreConfig => {
  const key: CADocumentTypeValue | undefined =
    record?.method ?? record?.bill_type ?? record?.doc_type;

  const commonConfig = {
    props: {defaultDisplayStep: true},
    initialValues: {
      facility: record?.facility,
      year: record?.year
    }
  };

  switch (key) {
    // Fuel Bill
    case CA_DOCUMENT_TYPE_VALUES.FOR_MACHINES:
      return {
        mainAPI: machineDetails,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            machineDetails(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
          deviceFuelAPI(),
          fuelTypeAPI(),
          deviceTypeAPI()
        ],
        PerquisiteMasterAPIIds: [],
        isConfigurator: false,
        isAction: false
      };

    case CA_DOCUMENT_TYPE_VALUES.FOR_VEHICLE:
      return {
        mainAPI: vehicleAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            vehicleAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
          vehicleTypeAPI(),
          vehicleFuelUsedJSON()
        ],
        PerquisiteMasterAPIIds: [],
        isConfigurator: false,
        isAction: false
      };

    case CA_DOCUMENT_TYPE_VALUES.FOR_REFRIGERANT:
      return {
        mainAPI: fugitiveAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            fugitiveAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
          emissionSourceJSON(),
          frequencyJSON(),
          refrigerantUsed(),
          refrigerantTypeJSON()
        ],
        PerquisiteMasterAPIIds: [],
        isConfigurator: false,
        isAction: false
      };

    // Electricity Bills
    case CA_DOCUMENT_TYPE_VALUES.RENEWABLE:
      return {
        mainAPI: electricityAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: {key: 'renewableType', value: 'Renewable'},
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            electricityAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
          renewableTypeAPI()
        ],
        PerquisiteMasterAPIIds: [],
        isConfigurator: false,
        isAction: false
      };

    case CA_DOCUMENT_TYPE_VALUES.NON_RENEWABLE:
      return {
        mainAPI: electricityAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: {key: 'renewableType', value: 'Non-renewable'},
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            electricityAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
          electricBoard()
        ],
        PerquisiteMasterAPIIds: [],
        isConfigurator: false,
        isAction: false
      };

    case CA_DOCUMENT_TYPE_VALUES.RAW_MATERIAL_AVERAGE:
      return {
        mainAPI: rawMaterialAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            rawMaterialAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
          productInfoAPI(
            APITypeEnum.GET_ALL,
            undefined,
            `${record?.company}/${record?.year}`
          )
        ],
        PerquisiteMasterAPIIds: [],
        isConfigurator: false,
        isAction: false
      };

    case CA_DOCUMENT_TYPE_VALUES.RAW_MATERIAL_SUPPLIER_SPECIFIC:
      return {
        mainAPI: rawMaterialAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            rawMaterialAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
          supplierInfo(
            APITypeEnum.GET_ALL,
            'company',
            `${record?.company}/${record?.year}/upstream`
          ),
          productInfoAPI(
            APITypeEnum.GET_ALL,
            undefined,
            `${record?.company}/${record?.year}`
          )
        ],
        PerquisiteMasterAPIIds: [PerquisiteMasterAPIIds.SUPPLIER],
        isConfigurator: false,
        isAction: false
      };

    case CA_DOCUMENT_TYPE_VALUES.CAPITAL_GOOD_AVERAGE:
      return {
        mainAPI: capitalGoodsAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            capitalGoodsAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId)
        ],
        PerquisiteMasterAPIIds: [],
        isConfigurator: false,
        isAction: false
      };

    case CA_DOCUMENT_TYPE_VALUES.CAPITAL_GOOD_SUPPLIER_SPECIFIC:
      return {
        mainAPI: capitalGoodsAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            capitalGoodsAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId)
        ],
        PerquisiteMasterAPIIds: [],
        isConfigurator: false,
        isAction: false
      };

    case CA_DOCUMENT_TYPE_VALUES.UPSTREAM_TRANSPORT:
      return {
        mainAPI: supplyChainAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            supplyChainAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
          supplierInfo(
            APITypeEnum.GET_ALL,
            undefined,
            `${record?.facility}/${record?.year}/upstream`
          ),
          frequencyJSON(),
          modeOfTransportJSON()
        ],
        PerquisiteMasterAPIIds: [PerquisiteMasterAPIIds.SUPPLIER],
        isConfigurator: false,
        isAction: false
      };

    case CA_DOCUMENT_TYPE_VALUES.DOWNSTREAM_TRANSPORT:
      return {
        mainAPI: supplyChainAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            supplyChainAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
          supplierInfo(
            APITypeEnum.GET_ALL,
            undefined,
            `${record?.facility}/${record?.year}/downstream`
          ),
          frequencyJSON(),
          modeOfTransportJSON()
        ],
        PerquisiteMasterAPIIds: [PerquisiteMasterAPIIds.SUPPLIER],
        isConfigurator: false,
        isAction: false
      };

    case CA_DOCUMENT_TYPE_VALUES.BUSINESS_TRAVEL_TICKETS:
      return {
        mainAPI: businessTravelAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            businessTravelAPI(
              APITypeEnum.GET_ONE,
              {},
              record?.referenceRecordId
            ),
          modeOfTransportTravJSON(),
          frequencyJSON()
        ],
        PerquisiteMasterAPIIds: [],
        isConfigurator: false,
        isAction: false
      };

    case CA_DOCUMENT_TYPE_VALUES.WATER_BILLS:
      return {
        mainAPI: waterAPI,
        billType: key,
        componentName: key,
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [
          record?.referenceRecordId &&
            waterAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
          waterSourceJSON()
        ],
        PerquisiteMasterAPIIds: [],
        isConfigurator: false,
        isAction: false
      };
    default:
      return {
        mainAPI: undefined,
        billType: key ?? '',
        componentName: '',
        ...commonConfig,
        type: null,
        PerquisiteMasterAPIs: [],
        PerquisiteMasterAPIIds: [],
        isConfigurator: false,
        isAction: false
      };
  }
};

export default getPrerequisiteMasterData;
